import { selectApiData } from 'util/selector/apiSelector';

import { AxiosInstance } from 'axios';

import {
  mapProjectLayoutDtoToModel,
  mapProjectLayoutModelToDto,
  ProjectLayoutModel,
} from './dto/ProjectLayout.dto';

export class ProjectLayoutApi {
  constructor(private client: AxiosInstance) {}

  fetch(projectId: number): Promise<ProjectLayoutModel> {
    return this.client
      .get(`/api/v1/project/${projectId}/layout`)
      .then(selectApiData)
      .then(mapProjectLayoutDtoToModel);
  }

  save(projectId: number, data: ProjectLayoutModel): Promise<ProjectLayoutModel> {
    return this.client
      .post(`/api/v1/project/${projectId}/layout`, mapProjectLayoutModelToDto(data))
      .then(selectApiData)
      .then(mapProjectLayoutDtoToModel);
  }
}
